import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.css']
})
export class ViewerComponent implements OnInit {

  //declare variables
  strVideo: string = '';
  strLink: string = '';
  strTitle: string = '';

  //inject services
  constructor(private route: ActivatedRoute, private mds: MetaService) { }

  //initialize the page
  ngOnInit(): void {
    //get the parameters passed to the component
    this.route.paramMap.subscribe(p => {
      //get the link passed
      this.strVideo = p.get('page');

      //see what was requested
      if (this.strVideo == 'demo') {
        //load demo
        this.strTitle = 'RegScale Demo Video';
        this.strLink = 'https://www.youtube.com/embed/v7TjHCc1tFg';
      } else {
        //load requested training video
        this.strTitle = 'RegScale Training Video';
        this.strLink = 'https://www.youtube.com/embed/' + this.strVideo;
      }
    });

    //SEO Optimization
    var strTitle = 'RegScale - YouTube Viewer';
    var description = 'Viewer for watching RegScale YouTube videos about RegScale';
    var keywords = 'RegScale, RegScale, YouTube, videos';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
